import { useQueryClient } from "@tanstack/react-query";

// The Settings page forms prefill from this cached query once, at mount (useSmsDefaultSender reads
// "settings-list" too). Refetch it after every successful save, so a form mounted later from a stale
// cache never posts old values back over what was just saved, and the readiness panel stays current.
export const useInvalidateSettings = () => {
  const queryClient = useQueryClient();

  return () => queryClient.invalidateQueries({ queryKey: ["settings-list"] });
};
